/**
 * @author MrZenW
 * @email MrZenW@Gmail.com, https://MrZenW.com
 * @create date 2021-05-25 13:21:37
 * @modify date 2021-05-25 13:21:37
 * @desc [description]
 */
// const React = require('react');
// eslint-disable-next-line no-use-before-define
import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { init, reportError } from './libraries/error_report';

// sentry.io begining
type MyConsole = (typeof console) & {
  reportError: any;
}
(console as MyConsole).reportError = reportError;
init();
// sentry.io end

// https://github.com/microsoft/TypeScript/issues/33128#issue-486675867
type MyWindow = (typeof window) & {
  FontAwesomeConfig: any;
}
(window as MyWindow).FontAwesomeConfig = Object.assign(
  (window as MyWindow).FontAwesomeConfig || {},
  { autoReplaceSvg: 'nest' },
);

require('$/assets/styles/colours.css?noPostcss');
require('bootstrap/scss/bootstrap.scss');
require('$/assets/styles/all.scss');
require('@fortawesome/fontawesome-free/js/fontawesome');
require('@fortawesome/fontawesome-free/js/solid');
require('@fortawesome/fontawesome-free/js/regular');
require('@fortawesome/fontawesome-free/js/brands');
require('animate.css');
require('bootstrap-icons/font/bootstrap-icons.css');
require('$/services/devtool_service');
require('$/services/theme_service');

const { render } = require('react-dom');
const Loading = require('$/components/Loading');
const { SessionContext } = require('$/components/session_context');
const configService = require('$/services/config_service');
const { grabSessionService } = require('$/services/session_service');
const { promiseKeeper } = require('$/libraries/promise-keeper');
const { getEmbeddedWebglContext } = require('$/libraries/embedded_webgl_context');
const App = require('./App');

const createSession = (sessionId?: string) => {
  return configService.grabSessionInfo(sessionId)
    .then((sessionInfo: any) => {
      configService.currentSessionId = sessionInfo.sessionId;
      const sessionService = grabSessionService(sessionInfo.sessionId);
      sessionService.sessionDoc = sessionInfo;
      return sessionService;
    });
};
const fetchGlobalConfigs = async (sessionService: any) => {
  console.log('Fetching global configs');

  const [isToolboxError, toolboxError, toolboxResp] = await promiseKeeper(sessionService.apiService.configApi.getGlobalItem('blockly_toolbox'));
  if (isToolboxError) {
    console.error(toolboxError);
  } else {
    configService.setConfigItem('global/blockly_toolbox', toolboxResp.data.configDoc || {});
  }
  const [isFirmwareVersionError, firmwareVersionError, firmwareVersionResp] = await promiseKeeper(sessionService.apiService.configApi.getGlobalItem('robot_firmware_version'));
  if (isFirmwareVersionError) {
    console.error(firmwareVersionError);
  } else {
    configService.setConfigItem('global/robot_firmware_version', firmwareVersionResp.data.configDoc || {});
  }
  const [accountMenuError, , accountMenuResp] = await promiseKeeper(sessionService.apiService.configApi.getGlobalItem('account-menu'));
  if (!accountMenuError) configService.setConfigItem('global/account-menu', accountMenuResp.data.configDoc || {});
  // weekly challenge
  const [isWeeklyChallengeError, weeklyChallengeError, weeklyChallengeResp] = await promiseKeeper(sessionService.apiService.configApi.getGlobalItem('weekly-challenge'));
  if (isWeeklyChallengeError) {
    console.error(weeklyChallengeError);
  } else {
    console.log(weeklyChallengeResp);
    configService.setConfigItem('global/weekly-challenge', weeklyChallengeResp.data.configDoc || {});
  }
  // theme pack
  const [isActiveThemeError, activeThemeError, activeThemeResp] = await promiseKeeper(sessionService.apiService.configApi.getGlobalItem('active-theme'));
  if (isActiveThemeError) {
    console.error(activeThemeError);
  } else {
    console.log(activeThemeResp);
    configService.setConfigItem('global/active-theme', activeThemeResp.data.configDoc || {});
  }
};

const onVisibilityChange = () => {
  if (document.visibilityState === 'visible') {
    configService.connectSession();
  } else {
    configService.disconnectSession();
  }
};

// Only attach the visibilitychange event listener if the app is not running in an iframe to prevent multiple listeners
if (window.location === window.parent.location) {
  document.addEventListener('visibilitychange', onVisibilityChange);
}

(async () => {
  const { sessionIdFromQuery, isEmbeddedWebglView } = getEmbeddedWebglContext();

  render(
    <Loading fullScreen>Starting Kainundrum...</Loading>,
    document.getElementById('root'),
  );
  await configService.fetchClientInfo();
  const initialSessionId = (isEmbeddedWebglView && sessionIdFromQuery)
    ? sessionIdFromQuery
    : configService.currentSessionId;

  let [isSessionError, sessionError, sessionService] = await promiseKeeper(createSession(initialSessionId));
  if (isSessionError) {
    if (!isEmbeddedWebglView) {
      alertLib.alertError(sessionError);
    }
    sessionService = await createSession((isEmbeddedWebglView && sessionIdFromQuery) ? sessionIdFromQuery : undefined);
  }

  if (!isEmbeddedWebglView) {
    await sessionService.createUserService();
    await fetchGlobalConfigs(sessionService);
  }
  // await fetchGlobalConfig();
  let googleRecaptchaKey = '';
  if (__PRODUCTION__) {
    googleRecaptchaKey = process.env.GOOGLE_RECAPTCHA_SITE_KEY || '';
  }
  render(
    <GoogleReCaptchaProvider
      reCaptchaKey={googleRecaptchaKey}
    >
      <SessionContext.Provider value={{ sessionService, sessionId: sessionService.sessionId }}>
        <App />
      </SessionContext.Provider>
    </GoogleReCaptchaProvider>,
    document.getElementById('root'),
  );
})().catch((error) => {
  console.error('Application startup failed', error);
  render(
    <Loading fullScreen error onRetry={() => window.location.reload()}>
      Kainundrum could not start. Check your connection and try again.
    </Loading>,
    document.getElementById('root'),
  );
});
